export const breakPointMobile = '959px'
